import type { ReactNode } from 'react'
import { BrandLockup } from '@/components/BrandLockup'

/**
 * The frame around every screen someone sees before they are signed in — sign
 * in, the emailed link, forgotten and new passwords, an invitation, signup.
 *
 * Plan View gives these the brand: on a wide screen a blackwood panel carries the
 * lockup and the one display line the system allows, beside the page ground
 * where the form sits. On a narrow one the panel goes and the lockup sits above
 * the form. Six pages each built their own centered card before this, and only
 * two of them showed the mark at all.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-svh bg-page lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="hidden flex-col justify-between gap-10 bg-brand-surface p-10 text-on-brand lg:flex">
        <BrandLockup ground="dark" />
        <p className="m-0 max-w-[16ch] text-display font-semibold [text-wrap:balance]">
          Made for venues. By venue people.
        </p>
        <p className="m-0 text-small text-on-brand-muted">Events, floor plans, leads and the run of the day, in one calm place.</p>
      </aside>
      <main className="flex flex-col items-center justify-center gap-8 px-4 py-12">
        <div className="lg:hidden">
          <BrandLockup />
        </div>
        <div className="flex w-full flex-col items-center">{children}</div>
      </main>
    </div>
  )
}
